module.exports = __webpack_public_path__ + "static/media/lamina15actividad.09e1d737.png";